import { db } from "../../../config/firebaseconfig"
import forOwn from 'mout/object/forOwn'

export default function postFeedback (item, feedback) {
  if (item && feedback) {
    const batch = db.batch()
    const ref = db.collection('contentItems').doc(item.itemId)
    let answers = []
    forOwn(item.answers, (val, key) => {
      const answer = {...val, key}
      answers.push(answer)
    })
    answers.forEach(({key}) => {
      const updateKey = `answers.${key}.feedback`
      batch.update(ref, {[updateKey]: feedback})
    })
    return batch.commit()
  } else return Promise.reject()
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageContent/postFeedback.js